/**
 * <s-header-scroll> — Marks the closest <header> with `data-scrolled` once the
 * page scrolls past a small threshold, so CSS can switch a transparent header
 * to its solid state. Renders nothing itself.
 *
 * Attributes:
 *   threshold — scroll distance in px before the header turns solid (default 8).
 */
class SHeaderScroll extends HTMLElement {
  #ac;
  #raf = null;

  connectedCallback() {
    const header = this.closest('header');
    if (!header) return;
    this.#ac = new AbortController();
    const threshold = Number(this.getAttribute('threshold')) || 8;

    const update = () => {
      this.#raf = null;
      header.toggleAttribute('data-scrolled', window.scrollY > threshold);
    };

    window.addEventListener('scroll', () => {
      if (this.#raf === null) this.#raf = requestAnimationFrame(update);
    }, { passive: true, signal: this.#ac.signal });

    update();
  }

  disconnectedCallback() {
    this.#ac?.abort();
    if (this.#raf !== null) cancelAnimationFrame(this.#raf);
    this.#raf = null;
  }
}

if (!customElements.get('s-header-scroll')) {
  customElements.define('s-header-scroll', SHeaderScroll);
}
